import React, { useRef } from 'react'
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import { closeListModal, fetchCoupons } from '../../../../../Features/couponsSlice';
import TickGreen from '../../../../../Assets/Modals/TickGreen.svg';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { updateCoupon } from '../../../../../lib/utils/apiCalls';
import { formatDateToMMDDYYYY } from '../../../../../lib/utils/utils';

function ExpireConfirmation() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeListModal());
    });

    const selectedKebabItem = useSelector((state) => state.coupons.selectedKebabItem);

    const handleCancelClick = () => {
        dispatch(closeListModal());
    }

    const handleExpireClick = async () => {
        try {
            let today = new Date();
            let yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);

            let yesterdayStart = new Date(yesterday.setHours(0, 0, 0, 0)).toISOString();
            let yesterdayEnd = new Date(yesterday.setHours(23, 59, 59, 999)).toISOString();

            const response = await updateCoupon({
                isVisible: false,
                isExpired:true
            }, selectedKebabItem.id);

            if (response?.status === 200) {
                showToast('Coupon expired.', 'success');
                dispatch(closeListModal());
                dispatch(fetchCoupons());
            }
            else {
                showToast('Error expiring coupon.', 'error');
            }
        }
        catch (err) {
            showToast('Error expiring coupon.', 'error');
        }
    };

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Expire Coupon</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Are you sure you want to expire this coupon? All coupon data will be removed from the live store.</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleExpireClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-[#DC2626] shadow-[0px_1px_2px_0px_#0000000D]'>Expire</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExpireConfirmation;
